export const abTestingFeatures = {
  SGSPT_ABTesting_SSGuide: 'SGSPT_ABTesting_SSGuide',
  SGSPT_ABTesting_Overhaul: 'SGSPT_ABTesting_Overhaul',
} as const;

export interface AbTestingConfig {
  [abTestingFeatures.SGSPT_ABTesting_SSGuide]: boolean;
  [abTestingFeatures.SGSPT_ABTesting_Overhaul]: boolean;
}

export type AbTestingFeature = keyof typeof abTestingFeatures;
